import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useMaterialUIController, setLayout } from "../../context";
import MaterialBox from "../../components/MaterialBox";
import DashboardFooter from "./components/Footer";
import DashboardNavbar from "./components/Navbar";


function DashboardLayout({ children, isCheckedIn, onClick }) {
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, "dashboard");
    }, [pathname]);

    return (
        <MaterialBox
            sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
                p: 2,
                position: "relative",

                [breakpoints.up("xl")]: {
                    marginLeft: miniSidenav ? pxToRem(100) : pxToRem(250),
                    transition: transitions.create(["margin-left", "margin-right"], {
                        easing: transitions.easing.easeInOut,
                        duration: transitions.duration.standard,
                        
                    }),
                },
            })}
        >
            <DashboardNavbar  onClick={onClick} isCheckedIn={isCheckedIn} />
            <div style={{marginTop:"2%"}}>

            </div>
            <div
            // style={{ minHeight: "74vh" }}
            >
                {children}
            </div>
            <MaterialBox sx={{ mt: 2 }}>
                <DashboardFooter />
            </MaterialBox>
        </MaterialBox>
    );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
    children: PropTypes.node.isRequired,
    isCheckedIn: PropTypes.bool,
    onClick: PropTypes.func,
};

export default DashboardLayout;